// app/i18n/settings.tsx
export const fallbackLng = "en";
export const languages = [fallbackLng, "fr"] as const;
export const defaultNS = "common";
export const cookieName = "NEXT_LOCALE";
export const headerName = "x-i18next-current-language";

export type Lang = (typeof languages)[number];

// Import des ressources
import enCommon from "@/app/i18n/locales/en/common.json";
import frCommon from "@/app/i18n/locales/fr/common.json";
import enLanding from "@/app/i18n/locales/en/landing.json";
import enSignIn from "@/app/i18n/locales/en/signIn.json";
import frLanding from "@/app/i18n/locales/fr/landing.json";
import frSignIn from "@/app/i18n/locales/fr/signIn.json";
import enComponents from "@/app/i18n/locales/en/components.json";
import frComponents from "@/app/i18n/locales/fr/components.json";
import enDrill from "@/app/i18n/locales/en/drill.json";
import frDrill from "@/app/i18n/locales/fr/drill.json";
import enDrillManagement from "@/app/i18n/locales/en/drill_management.json";
import frDrillManagement from "@/app/i18n/locales/fr/drill_management.json";
import enConstants from "@/app/i18n/locales/en/constants.json";
import frConstants from "@/app/i18n/locales/fr/constants.json";
import enPersona from "@/app/i18n/locales/en/persona.json";
import frPersona from "@/app/i18n/locales/fr/persona.json";
import enScenario from "@/app/i18n/locales/en/scenario.json";
import frScenario from "@/app/i18n/locales/fr/scenario.json";
import enSettings from "@/app/i18n/locales/en/settings.json";
import frSettings from "@/app/i18n/locales/fr/settings.json";
import enDashboard from "@/app/i18n/locales/en/dashboard.json";
import frDashboard from "@/app/i18n/locales/fr/dashboard.json";
import enHome from "@/app/i18n/locales/en/home.json";
import frHome from "@/app/i18n/locales/fr/home.json";
import enSolutions from "@/app/i18n/locales/en/solutions.json";
import frSolutions from "@/app/i18n/locales/fr/solutions.json";
export const resources = {
  en: {
    common: enCommon,
    landing: enLanding,
    signIn: enSignIn,
    components: enComponents,
    drill: enDrill,
    drill_management: enDrillManagement,
    constants: enConstants,
    persona: enPersona,
    scenario: enScenario,
    settings: enSettings,
    dashboard: enDashboard,
    home: enHome,
    solutions: enSolutions,
  },
  fr: {
    common: frCommon,
    landing: frLanding,
    signIn: frSignIn,
    components: frComponents,
    drill: frDrill,
    drill_management: frDrillManagement,
    constants: frConstants,
    persona: frPersona,
    scenario: frScenario,
    settings: frSettings,
    dashboard: frDashboard,
    home: frHome,
    solutions: frSolutions,
  },
} as const;

export type ResourcesType = typeof resources;
export type Namespace = keyof ResourcesType["en"];
